import { Button } from 'ypf-pas-general-ui-components';
import { BsChevronLeft } from 'react-icons/bs';
import { useHistory } from 'react-router';
import PropTypes from 'prop-types';

import './HeaderTitle.scss';

const HeaderTitle = (props) => {
  const { title, arrowLeft } = props;
  const history = useHistory();

  const goBack = () => {
    history.goBack();
  };

  return (
    <div className="header-title">
      {arrowLeft && (
        <Button
          colorIcon="primary"
          icon={BsChevronLeft}
          onClick={goBack}
          sizeIcon="17px"
          type="button"
          variant="white"
          widthButton="40px"
        />
      )}
      <h2 className="title">{title}</h2>
    </div>
  );
};

HeaderTitle.propTypes = {
  title: PropTypes.string,
  arrowLeft: PropTypes.bool
};

HeaderTitle.defaultProps = {
  title: '',
  arrowLeft: true
};

export default HeaderTitle;
